module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/studio-suns_access_02-f02e0e599f4358f02e38a90c10147e26.jpg";